import { toJS } from 'mobx';

import { isAuOrNzRRQuestion } from 'src/stores/JobStore/utils/isAuOrNzRRQuestion';

import { RR_QUESTION_SOURCE } from '../../../constants/roleRequirementsTypes';

import type { IQuestionnaireStore } from './../../JobStore/QuestionnaireStore';
import { FilterQuestion, type IFilterQuestion } from './FiltersStore';

export const transformQuestionnaireIntoFilterQuestions = (
  questionnaire: IQuestionnaireStore,
): IFilterQuestion[] => {
  const questions = toJS(questionnaire.questions) ?? [];

  const questionIdExcludeList = [
    '14', // Advanced Availability question always has a localId
  ]; // localIds
  const questionsForFilters = questions.filter((question) => {
    const isLibraryQuestion = question.source === RR_QUESTION_SOURCE.LIBRARY;
    const isExcludedQuestionId =
      question.id &&
      isAuOrNzRRQuestion(question.globalId) &&
      questionIdExcludeList.includes(question.id);

    const isFilterableQuestion = isLibraryQuestion && !isExcludedQuestionId;

    return isFilterableQuestion && question.answers !== null;
  });

  questionsForFilters.sort((a, b) => a.order - b.order);
  questionsForFilters.forEach((question) => {
    question.answers?.sort((a, b) => a.order - b.order);
  });

  return questionsForFilters.map((question) =>
    FilterQuestion.create({
      questionInfo: question,
      answers: question.answers?.map((answer) => ({
        answerInfo: answer,
      })),
      simplifiedAnswers: question.hirerExperience?.simplifiedAnswers
        ? question.hirerExperience?.simplifiedAnswers.map((answer) => ({
            answerInfo: answer,
          }))
        : [],
    }),
  );
};
